import { OssFileDetail } from '@eastcoal/api/nexus/interface'

import { UploadItem } from './interface'

export const transformOssDetail = ({
  ossId,
  filename,
  accessUrl,
  thumbnailUrl,
  mimeType
}: OssFileDetail): UploadItem => {
  const key = `${ossId}`
  const fileName = `${filename}`
  const url = accessUrl
  const thumbUrl = thumbnailUrl ?? url
  return {
    uid: key,
    ossId: key,
    name: fileName,
    fileName,
    url,
    thumbUrl,
    type: mimeType,
    status: 'done'
  }
}
